import React, { useState, useEffect } from "react";
import Text from "components/common/Text";

const CountdownTimer = ({ targetTime, onExpire, size = "large" }) => {
  const [timeLeft, setTimeLeft] = useState("");

  const calculateTimeLeft = () => {
    if (!targetTime) return "00:00:00";

    const now = new Date();
    const target = new Date(targetTime);
    const difference = target - now;

    if (difference <= 0) {
      if (onExpire) onExpire();
      return "00:00:00";
    }

    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / 1000 / 60) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    return [
      hours.toString().padStart(2, "0"),
      minutes.toString().padStart(2, "0"),
      seconds.toString().padStart(2, "0"),
    ].join(":");
  };

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetTime]);

  const fontSize = size === "large" ? "24px" : "16px";

  return (
    <Text
      component="span"
      sx={{
        color: "#D97706",
        fontWeight: 700,
        fontSize: fontSize,
        ml: 1,
      }}
    >
      {timeLeft}
    </Text>
  );
};

export default CountdownTimer;
